/**
 * Data-context rows are labelled bare in the chart's right column ("Financial",
 * "Marketing") but read as "<name> Data" everywhere they appear as a breadcrumb
 * chip, related tag or popover heading — see Figma `5:18826` (chip "Financial
 * Data" above the row "Financial") and `5:20339` (pipe header "Engineering >
 * Marketing Data").
 *
 * Labels reach the UI from the warehouse, and some already carry the word
 * ("Marketing Data", "HR Data"), so appending unconditionally produces
 * "Marketing Data Data". Append only when the label doesn't already end in it.
 */
export function dataContextChipLabel(label: string): string {
  return /\bdata\s*$/i.test(label) ? label : `${label} Data`;
}
